import { useWeb3React } from '@web3-react/core';
import { BigNumber, Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState
} from 'react';
import { SignMessage } from './SignMessage';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { SectionDivider } from './SectionDivider';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';

import { 
  getFromURI
} from './IpfsApp';

//Contract OG
//import NFTArtifact from '../artifacts/contracts/NFT.sol/NFT.json';
//import NFTAddress from '../artifacts/contracts/NFT.sol/NFT-address.json';
/*
//Contract ALPHA TEST
import NFTArtifact from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import NFTAddress from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';
*/

//CFP LIVE
import CFP_Artifact from '../live_artifacts/contracts/CosmicForcePaydirt.sol/CosmicForcePaydirt.json';
import CFP_Address from '../live_artifacts/contracts/CosmicForcePaydirt.sol/CosmicForcePaydirt-address.json';

//MEGA PAYDIRT NFT
import CosmicForcePaydirtNFTArtifact from '../live_artifacts/contracts/CosmicForcePaydirtNFT.sol/CosmicForcePaydirtNFT.json';
import CosmicForcePaydirtNFTAddress from '../live_artifacts/contracts/CosmicForcePaydirtNFT.sol/CosmicForcePaydirtNFT-address.json';

//MEGA PAYDIRT NFT SELL
import CosmicForcePaydirtNFTSellArtifact from '../live_artifacts/contracts/CosmicForcePaydirtNFTSell.sol/CosmicForcePaydirtNFTSell.json';
import CosmicForcePaydirtNFTSellAddress from '../live_artifacts/contracts/CosmicForcePaydirtNFTSell.sol/CosmicForcePaydirtNFTSell-address.json';


const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;



const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function PaydirtNFTSellApp(): ReactElement {
  return (
    <StyledAppDiv>
      <NFTMarketplaceContract />
    </StyledAppDiv>
  );
}

export function NFTMarketplaceContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library } = context;

  const [signer, setSigner] = useState<Signer>();
  const [items, setItems] = useState<any[]>([]);
  const [fuseItems, setFuseItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const account = context.account;
 
  const [totalSelected, setTotalSelected] = useState(0);
  

  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //test for account change
  useEffect(() => {
    setLoading(true);
    handleAttachContract();
  }, [account]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

   // window.alert("do change");


    async function attachNFTContract(signer: Signer): Promise<void> {
      
      const PAYDIRTNFT = new ethers.ContractFactory(
        CosmicForcePaydirtNFTArtifact.abi,
        CosmicForcePaydirtNFTArtifact.bytecode,
        signer
      );
    
      try {

        const PAYDIRTnft = await PAYDIRTNFT.attach(CosmicForcePaydirtNFTAddress.address);


        let listItems = [];

        const balancePAYDIRTNFT = await PAYDIRTnft.balanceOf(account);

        for(let i =0; i < balancePAYDIRTNFT; i++){
          const tokenId = await PAYDIRTnft.tokenOfOwnerByIndex(account,i);
          var uri = await PAYDIRTnft.tokenURI(tokenId);
         
          const value = await PAYDIRTnft.getValue(tokenId);

          const metadata = getFromURI(uri);

        const itemId = (tokenId).toString();
        const valueString = (value).toString();

        const itemSelected = '0';

        let item = {
        //  itemIdHex: itemIdHex,
          itemId: itemId,
        //  price: metadata.price,
        //  name: metadata.name,
          description: metadata.description,
        //  ticker: metadata.ticker,
          image: metadata.image,
          value: valueString,
          selected: itemSelected
        }
        listItems.push(item);
 
        }

        setItems(listItems);
        setLoading(false);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }

  function handleSellPaydirtNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    
    var paydirtNftId = Number(event.currentTarget.id);
    var paydirtNftValue = Number(event.currentTarget.value);



    async function sellNFT(signer: Signer, _paydirtNftId: Number, _paydirtNftValue: Number): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        CosmicForcePaydirtNFTArtifact.abi,
        CosmicForcePaydirtNFTArtifact.bytecode,
        signer
      );

      const SELLNFT = new ethers.ContractFactory(
        CosmicForcePaydirtNFTSellArtifact.abi,
        CosmicForcePaydirtNFTSellArtifact.bytecode,
        signer
      );

      const CFP = new ethers.ContractFactory(
        CFP_Artifact.abi,
        CFP_Artifact.bytecode,
        signer
      );

      try {

  // window.alert(_paydirtNftId);
  //  window.alert(_paydirtNftValue);


        const CFP_Contract = await CFP.attach(CFP_Address.address);

        const nftContract = await NFT.attach(CosmicForcePaydirtNFTAddress.address);

        const nftSellContract = await SELLNFT.attach(CosmicForcePaydirtNFTSellAddress.address);

        var cost = 0;
        var costString = "0";

        const setTxn = await nftContract.approve(CosmicForcePaydirtNFTSellAddress.address, _paydirtNftId);
        await setTxn.wait();

        window.alert(`PAYDIRT NFT #${_paydirtNftId} Approve Success!`);

        const setTxn2 = await nftSellContract.sell(_paydirtNftId, _paydirtNftValue);
        await setTxn2.wait();

        window.alert(`Sold PAYDIRT NFT #${_paydirtNftId} FOR ${_paydirtNftValue} CFP`);

        //reload page
        setLoading(true);
        handleAttachContract();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    sellNFT(signer, paydirtNftId, paydirtNftValue);
  }

  
  if (loading) return (
    <main style={{ padding: "1rem 0" }}>
       <h2>Loading PAYDIRT NFT(s)...</h2>
    </main>
  )
    
  return (
    <>
      <div className="flex justify-center">
      {items.length > 0 ?
        <div className="px-5 container">
          <h2>PAYDIRT NFT(s) with Account {typeof account === 'undefined'
          ? ''
          : account
          ? `${account.substring(0, 6)}...${account.substring(
              account.length - 4
            )}`
          : ''} </h2>
           <div>&nbsp;</div>
         
          <Form>
          <Row xs={1} md={2} lg={4} className="g-4 py-5">
            {items.map((item, idx) => (
              <Col key={idx}  className=" text-center py-0">
                <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                  <Card.Body>
                    <Card.Img variant="top" src={item.image} />
                    
                    </Card.Body>
                  <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b", padding: "0.2rem 0.2rem" }}>
                  <Card.Text>
                    <h6>#{item.itemId} {item.description} </h6>
                  </Card.Text>
                  <Button id={`${item.itemId}`} value={`${item.value}`} onClick={handleSellPaydirtNFT} variant="primary" size="lg">
                    SELL FOR {item.value} $CFP
                  </Button>
                  </Card.Footer>
                </Card>
              </Col>
            ))}
          </Row>
          </Form>
        </div>
        : (
          <main style={{ padding: "1rem 0" }}>
            <h2>No PAYDIRT NFT(s)</h2>
          </main>
        )}
    </div>
    </>
  );
}
